import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
// import {LoginComponent} from '@app/auth/login/login.component';
import {SignupComponent} from '@app/auth/signup/signup.component';
import {Observable, Subject} from 'rxjs';

export interface LoginAndSignUpDataComponent {
  endUser: boolean;
  isInvitation: boolean;
  invitedEmail: string;
  permission: string;
}

export interface OpenDialog {
  data: LoginAndSignUpDataComponent;
  open: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  obLogin: Subject<OpenDialog> = new Subject<OpenDialog>();
  obSignUp: Subject<OpenDialog> = new Subject<OpenDialog>();

  constructor(private matDialog: MatDialog) {
  }

  openLoginSub(): Observable<OpenDialog> {
    return this.obLogin.asObservable();
  }

  openSignUpSub(): Observable<OpenDialog> {
    return this.obSignUp.asObservable();
  }

  openLogin(endUser = false, isInvitation = false, invitedEmail = null, permission = null) {
    this.obLogin.next({data: {endUser: endUser, isInvitation : isInvitation, invitedEmail : invitedEmail, permission: permission}, open: true});
  }

  openSignUp(endUser = false, isInvitation = false, invitedEmail = null, permission = null) {
    this.obSignUp.next({data: {endUser: endUser, isInvitation : isInvitation, invitedEmail : invitedEmail, permission: permission}, open: true});
  }

}
